import { Card, CardContent, CardHeader, CircularProgress, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip, Typography } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import logger from 'src/utils/logger';
// import { text } from "../../languages/index"
import axios from "src/utils/axios";
import { getUser, openBlob, safeRequestParam } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';


const useStyles = makeStyles(() => ({
  root: {},
  contentB: {
    minHeight: 430,
  },
  dividerB: {
    backgroundColor: '#FF9800'
  },
}));


function Bulten({ className, FisNo, readonly, tasks }) {

  const classes = useStyles();
  const [BultenData, setBultenData] = useState([]);
  const SessionUser = getUser();
  const BirimKodu = SessionUser.ServiceShopId;
  const TeknisyenKodu = SessionUser.TechnicianId;
  const [Loading, setLoading] = useState(true);
  let Data = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

  if (!readonly && (!Data || Data.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      Data = loadBaslandiJob();
    }
  }


  const Model = Data && Data[0] && Data[0]?.KUL_MODEL_KODU;

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      var ModelParam = "-1";
      if (Model !== "") {
        ModelParam = Model;
      }
      axios.get(`/GetArtemisBulten/${BirimKodu}/${TeknisyenKodu}/${safeRequestParam(ModelParam) || 'a'}`)
      .then((response) => {
        if (mounted) {
          const Deger = response.data === "" ? [] : response.data;
          setBultenData(Deger);
          setLoading(false);
        }
      }).catch(error => {
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [FisNo, BirimKodu, TeknisyenKodu, Model]);

  const BultenDetayAc = (log) => {
    setLoading(true);
    const dataBultenDetay = {
      BIRIM_KODU: SessionUser.ServiceShopId.toString(),
      SICIL_NO: SessionUser.UserId,
      FilePtr: log.FP,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/ArtemisBulten', dataBultenDetay, config)
      .then(response => {
        openBlob(response.data, log.BT + '_' + log.AY + '_' + log.BN);
        setLoading(false);
      })
  };

  const user = getUser();
  let user_types = user.TechnicianType.split(",");
  let klima_teknisyeni = false;
  user_types && user_types.forEach(u => {
    if (parseInt(u) === 26) {
      klima_teknisyeni = true;
    }
  });
  if (klima_teknisyeni) {
    return <Card>
      <CardHeader title="Yetki Kontrolü" />
      <Divider />
      <CardContent className={classes.contentB}>
        Yetkiniz bulunmadığı için sayfa görüntülenemiyor!..
      </CardContent>
    </Card>;
  }

  return (
    <div>

      {window.navigator.onLine ?
        <Card className={clsx(classes.root, className)}>
          <CardHeader title="Ürüne Ait Bültenler" />
          <Divider />
          <CardContent className={classes.contentB}>
            <div className={classes.inner}>
              {Loading ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                :
                Array.isArray(BultenData) && BultenData.map(log => (
                  <div key={log.BN}>
                    <List className={classes.root}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                          <div>
                            <Typography
                              component="span"
                              variant="h3"
                              className={classes.inline}
                              color="textPrimary">{log.GUN}</Typography>
                            <br />
                            <Typography
                              component="span"
                              variant="subtitle1"
                              className={classes.inline}
                              color="textPrimary">{log.AY.substring(0, 3)}
                            </Typography>
                            <br />
                            <Typography
                              component="span"
                              variant="subtitle1"
                              className={classes.inline}
                              color="textPrimary">{log.YIL}
                            </Typography>
                            <br />
                          </div>
                        </ListItemAvatar>
                        <ListItemText
                          primary={log.BT}
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                {log.A}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                        <ListItemSecondaryAction>
                          <Tooltip title="Bülten Göster">
                            <IconButton
                              color="primary"
                              edge="end"
                              onClick={() => BultenDetayAc(log)}
                              size="small">
                              <CloudDownloadIcon />
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider className={classes.dividerB} />
                    </List>
                  </div>
                ))}
            </div>
          </CardContent>
        </Card>
        :
        <Card className={clsx(classes.root, className)}>
          <CardHeader title="Ürüne Ait Bültenler" />
          <CardContent className={classes.contentB}>
            Offline oldugunuz için görüntüme yapılamıyor lütfen online moda geçtikten sonra tekrar deneyiniz!...
          </CardContent>
        </Card>
      }
    </div>
  );
}

Bulten.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(Bulten);

